module.exports = __webpack_public_path__ + "img/Plan Paul Formade Kopie.4065bde6.jpg";